import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { get as getFromLocalStorage, set as setToLocalStorage } from '@square/dashboard-utilities/utils/persistable';
function getLocalStorageKey(cardToken) {
  return `DebitCard.hasViewedReplacementCardShippingAddressPopup.${cardToken}`;
}
export function hasViewedReplacementCardAddressPopup(cardToken) {
  return Boolean(getFromLocalStorage(getLocalStorageKey(cardToken)));
}
export function setViewedReplacementCardAddressPopup(cardToken) {
  setToLocalStorage(getLocalStorageKey(cardToken), true, OneTrustConsent.FUNCTIONAL);
}